import { render, staticRenderFns } from "./PostQuestionnaire.vue?vue&type=template&id=52bc5d12&scoped=true"
import script from "./PostQuestionnaire.vue?vue&type=script&lang=js"
export * from "./PostQuestionnaire.vue?vue&type=script&lang=js"
import style0 from "./PostQuestionnaire.vue?vue&type=style&index=0&id=52bc5d12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bc5d12",
  null
  
)

export default component.exports